<template>
    <div class="md loading">
        <!-- <div v-if="typeof status === 'number'" :style="{ width: status + '%' }" class="line"></div>
        <div v-else :style="{ right: 0 }" class="line"></div>
        <div v-if="typeof status === 'number'" class="status">{{ status }}%</div>
        <div v-else-if="typeof status === 'string'" class="status">{{ status }}</div> -->
        <svg viewBox="0 0 66 66">
            <circle fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        }
    }
</script>

<style scoped lang="scss">

    .md.loading {
        $offset: 187;
        $duration: 1.4s;

        // background-repeat: no-repeat;
        // background-position: center;

        .lo.extend & {
            @extend %mask;
            z-index: 1200; //比 mask 高
        }

        .lo.page & {
            background-color: rgba-set($major-color, $opacity-l);
            min-height: 120px;
            border-radius: $border-radius;
            position: relative;
        }

        // .line {
        //     position: absolute;
        //     top: 0;
        //     left: 0;
        //     height: $interval-xs;
        //     background-color: $major-color;
        //     transition: $transition;
        // }

        // .status {
        //     $size: 80px;

        //     position: absolute;
        //     top: 50%;
        //     left: 50%;
        //     width: $size;
        //     line-height: $size;
        //     margin-top: -0.5 * $size;
        //     margin-left: -0.5 * $size;
        //     z-index: 1;
        //     text-align: center;
        //     font-size: $font-size-xl;
        // }

        svg {
            $size: 80px;

            position: absolute;
            top: 50%;
            left: 50%;
            width: $size;
            height: $size;
            margin-top: -0.5 * $size;
            margin-left: -0.5 * $size;
            animation: rotator $duration linear infinite;
        }

        circle {
            stroke-dasharray: $offset;
            stroke-dashoffset: 0;
            transform-origin: center;
            animation: dash $duration ease-in-out infinite, colors ($duration * 4) ease-in-out infinite;
        }

        @keyframes rotator {

            0% {
                transform: rotate(0deg);
            }

            100% {
                transform: rotate(270deg);
            }
        }

        @keyframes colors {

            0% {
                stroke: #4285F4;
            }

            25% {
                stroke: #DE3E35;
            }

            50% {
                stroke: #F7C223;
            }

            75% {
                stroke: #1B9A59;
            }

            100% {
                stroke: #4285F4;
            }
        }

        @keyframes dash {

            0% {
                stroke-dashoffset: $offset;
            }

            50% {
                stroke-dashoffset: $offset / 4;
                transform: rotate(135deg);
            }

            100% {
                stroke-dashoffset: $offset;
                transform: rotate(450deg);
            }
        }
    }
</style>
